import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { useAddNote } from "../../hooks/useCrm";
import { useParams } from "react-router-dom";
const initvalue = {
  IdS0alesOpportunities: null,
  Note: "",
};
export const AddNoteModal = ({ show, handleClose }) => {
  const { id } = useParams();
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const [note, setNote] = useState();
  useEffect(() => {
    setForm({
      ...form,
      IdS0alesOpportunities: id,
    });
  }, [id]);
  const { mutateAsync: AddNote } = useAddNote();
  const handleAddNote = async (data) => {
    await AddNote(data).then((response) => {
      setForm(initvalue);
    });
  };
  return (
    <BootstrapModal
      modaltitle="افزودن یادداشت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12 mb-2">
          <SimpleTextArea
            cols="10"
            rows="3"
            placeholder="یادداشت خود را اینجا بنویسید"
            onChange={(e) => {
              setForm({ ...form, Note: e.target.value });
            }}
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAddNote(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
